import styled from 'styled-components';

export const PolicyBox = styled.div`
  padding: 10px 0;
  position: relative;
  background-color: ${({ lightTheme, theme: { colors } }) =>
    lightTheme ? colors.black : colors.white};
  z-index: 9;

  p {
    color: ${({ lightTheme, theme: { colors } }) =>
      lightTheme ? colors.white : colors.black};
    font-size: 14px;
    letter-spacing: 0.16px;
    line-height: 28px;
    text-align: center;
    margin: 0;
  }

  .close {
    position: absolute;
    top: 14px;
    right: 20px;
    width: 20px;
    height: 20px;
    background-color: ${({ lightTheme, theme: { colors } }) =>
      lightTheme ? colors.white : colors.black};
    color: ${({ lightTheme, theme: { colors } }) =>
      lightTheme ? colors.black : colors.white};
    text-align: center;
    line-height: 20px;
    border-radius: 50%;
    font-size: 12px;
    cursor: pointer;
    transition: 0.3s all ease-in-out;
    border: 0;

    &:hover {
      background-color: ${({ theme: { colors } }) => colors.pink};
      color: ${({ lightTheme, theme: { colors } }) =>
        lightTheme ? colors.black : colors.white};
    }
  }

  a {
    color: ${({ theme: { colors } }) => colors.pink};
    text-decoration: underline;
    font-family: 'Proxima Nova';
    font-weight: 600;
  }

  i {
    vertical-align: middle;
  }
`;
